import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-desk/notice/list',
    method: 'post',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-desk/notice/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-desk/notice/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-desk/notice/submit',
    method: 'post',
    data: row
  })
}

export const getNotice = (id) => {
  return request({
    url: '/api/blade-desk/notice/detail',
    method: 'get',
    params: {
      id
    }
  })
}

// 密码有效期提示
export const checkPasswordTime = () => {
  return request({
    url: '/api/blade-user/checkPasswordTime',
    method: 'get',
    params: {
    }
  })
}

// 首页获取图表数据
export const getQueueFlagVehicleCount = () => {
  return request({
    url: '/api/data-board/getQueueFlagVehicleCount',
    method: 'get',
    params: {
    }
  })
}

// 获取统计车辆信息数据
export const getWeightSumInfo = () => {
  return request({
    url: '/api/data-board/getWeightSumInfo',
    method: 'get',
    params: {
    }
  })
}